export default __webpack_public_path__ + "img/b4a8bbbfa064b03f456d3be8492f0328.svg";